/* eslint-disable no-console */
import { HiNotification } from '@/js/common/HINotificationSupport';
import { MasterData as MasterDataEnum } from '@/js/enums/enums';
import { mapContractToERP, mapERPContractToLocal } from '@/js/mappers/contract';
import { mapERPCropToLocal } from '@/js/mappers/crop';
import { mapERPFarmerToLocal } from '@/js/mappers/farmer';
import { mapERPFieldToLocal } from '@/js/mappers/field';
import { useContractsStore } from '@/js/stores/contracts';
import { ApiModule, httpClient } from '../api';
import ContractService from './Contracts';
import CropService from './Crops';
import FarmerService from './Farmers';
import FieldService from './Fields';

import MasterData from './MasterData';

const geoServerTimacagro = 'https://gis.hispatecanalytics.com/geoserver/timacagro/wms?';
const geoServerRasterDates = 'https://gis.hispatecanalytics.com/gisw/ws/get_raster_dates/';
const geoServer = 'https://gis.hispatecanalytics.com/gisw/ws'; // Endpoint producción
const geoServerPort = 'https://gis.hispatecanalytics.com/geoserver';
const geoServerSigpacMap = 'https://gis.hispatecanalytics.com/gisw/ws/getmap/';
const geoServerFeatureInfo = 'https://gis.hispatecanalytics.com/gisw/ws/getfeatureinfo/';
const geoServerTemperatureHistogram = 'https://gis.hispatecanalytics.com/gisw/ws/get_raster_stats/';

/* const token = store.getters.getToken; */
/* let baseURL = store.getters.getUrl; */
/* store.watch((state) => state.url, (newValue, oldValue) => {
  baseURL = newValue;
}); */

/* if (token != null) {
  axios.defaults.headers.common.Authorization = `Bearer ${token}`;
} */

/* const authenticate = () => {
  const url = `${getHostApiERP}/${ApiModule.Login}/authenticate/`;
  const user = localStorage.getItem('username');
  const password = localStorage.getItem('password');
  // axios.defaults.headers.common.Authorization = '';
  console.log('authenticate');
  return Axios
    .post(url, { }, { headers: { Username: user, Password: password } })
    .then((response) => {
      store.commit('setToken', response.data);
      store.commit('setUser', localStorage.getItem('username'));
      // .defaults.headers.common.Authorization = `Bearer ${response.data}`;
    }).catch((error) => {
    });
};

axios.interceptors.response.use((response) => response, async (error) => {
  console.log(error.response.data);
  if (error.response.status === 401) {
    await authenticate();
  }
  return Promise.reject(error);
});
 */
export default {
  async contractsSincronizacion() {
    // axios.defaults.headers.common.Authorization = `Bearer ${getTokenERP()}`;

    await this.handleLoginResult();
  },

  async handleLoginResult() {
    await this.getInitialConfig();
    await this.syncMasterData();
    await this.syncEntitiesData();
  },

  async getInitialConfig() {
    // const url = `${getHostApiERP()}/${ApiModule.PurchaseContracts}/ObtenerConfiguracionInicial/`;
    /*  axios.post(`${getHostApiERP()}`.concat(`${ApiModule.PurchaseContracts}/ObtenerConfiguracionInicial/`),
      { headers }); */
    return httpClient().post(`${ApiModule.PurchaseContracts}/ObtenerConfiguracionInicial/`, null)
      .then(async (response) => {
        try {
          if (response.data.Valor) {
            const entries = Object.entries(response.data.Tag);
            entries.forEach((o) => {
              localStorage.setItem(o[0], o[1]);
            });
            /* for (const key in response.data.Mensaje) {
              if (Object.hasOwnProperty.call(response.data.Mensaje, key)) {
                const element = response.data.Mensaje[key];
                localStorage.setItem(key, element);
              }
            } */
          }
        } catch {
          console.error('PROBLEMAS EN LA CONFIGURACIÓN INICIAL');
        }
      }).catch((error) => {
        console.log(error.response.data);
        HiNotification.Alert(error.response.data.detail);
        return 'ko';
      })
      .finally(() => {
        this.loading = false;
      });
  },

  async syncMasterData() {
    const versioning = await this.getMasterDataVersioning();
    // console.log('out versioning', versioning);
    let maxVersion = localStorage.getItem('maxVersion');
    maxVersion ??= '';
    await this.getMasterData(versioning, maxVersion).then(async (response) => {
      // console.log('maste rdata response:', response);
      await this.handleMasterData(response.data);
    }).catch((error) => {
      console.log('master data error:', error);
    });
  },

  async syncEntitiesData() {
    const entityVersioning = await this.getEntitiesDataVersioning();
    let maxVersionEntities = localStorage.getItem('maxVersionEntities');
    maxVersionEntities ??= '';
    await this.getMasterData(entityVersioning, maxVersionEntities).then(async (response) => {
      // console.log('entities data response:', response);
      await this.handleEntitiesData(response.data);
    }).catch((error) => {
      console.log('entities data error:', error);
    });
  },

  async getMasterDataVersioning() {
    const result = {};

    const dcs = await MasterData.getAllPrimaryKeys('dcs');
    const campaign = await MasterData.getAllPrimaryKeys('campaign');
    const countries = await MasterData.getAllPrimaryKeys('countries');
    const ownershipTypes = await MasterData.getAllPrimaryKeys('ownershipTypes');
    const varieties = await MasterData.getAllPrimaryKeys('varieties');
    const qprotocols = await MasterData.getAllPrimaryKeys('qprotocols');
    const familiesOfVarieties = await MasterData.getAllPrimaryKeys('familiesOfVarieties');
    const vatRate = await MasterData.getAllPrimaryKeys('vatRate');
    const retention = await MasterData.getAllPrimaryKeys('retention');
    const business = await MasterData.getAllPrimaryKeys('business');
    const wayToPay = await MasterData.getAllPrimaryKeys('wayToPay');
    const zones = await MasterData.getAllPrimaryKeys('zones');

    result[MasterDataEnum.DataComplementary] = dcs.join(',');
    result[MasterDataEnum.Campaigns] = campaign.join(',');
    result[MasterDataEnum.Countries] = countries.join(',');
    result[MasterDataEnum.OwnershipTypes] = ownershipTypes.join(',');
    result[MasterDataEnum.Varieties] = varieties.join(',');
    result[MasterDataEnum.QualityProtocols] = qprotocols.join(',');
    result[MasterDataEnum.FamiliesOfVarieties] = familiesOfVarieties.join(',');
    result[MasterDataEnum.VatRate] = vatRate.join(',');
    result[MasterDataEnum.Retention] = retention.join(',');
    result[MasterDataEnum.Business] = business.join(',');
    result[MasterDataEnum.WayToPay] = wayToPay.join(',');
    result[MasterDataEnum.Zones] = zones.join(',');

    // console.log('result versioning', result);
    return result;
  },

  async getEntitiesDataVersioning() {
    const result = {};

    const farmers = await FarmerService.getAllPrimaryKeys();
    const fields = await FieldService.getAllPrimaryKeys();
    const crops = await CropService.getAllPrimaryKeys();
    const contracts = await ContractService.getAllPrimaryKeys();

    result[MasterDataEnum.Farmers] = farmers.join(',');
    result[MasterDataEnum.Fields] = fields.join(',');
    result[MasterDataEnum.Crops] = crops.join(',');
    result[MasterDataEnum.Contracts] = contracts.join(',');

    // console.log('result entity versioning', result);
    return result;
  },

  async handleMasterData(response) {
    const data = response.Tag;
    const ownershipTypes = data.OwnershipTypes;
    const dcs = data.DataComplementary;
    const protocols = data.QualityProtocols;
    const campaigns = data.Campaigns;
    const varieties = data.Varieties;
    const countries = data.Countries;
    const familiesOfVarieties = data.FamiliesOfVarieties;
    const vatRate = data.VatRate;
    const business = data.Business;
    const retention = data.Retention;
    const wayToPay = data.WayToPay;
    const zones = data.Zones;

    // console.log('MASTER DATA:', data);
    // console.log('vatrage', vatRate);

    dcs.NewData.forEach((dc) => {
      if (dc.dataType === 4) {
        dc.values = dcs.DataComplementaryList.filter((listValue) => listValue.code === dc.code) || [];
      }
    });

    const maxVersion = data.MaxVersion;
    if (maxVersion !== '') {
      localStorage.setItem('maxVersion', maxVersion);

      const store = useContractsStore();
      store.lastSyncMasterData = new Date().toString();
    }
    // console.log(maxVersion);

    const syncPromises = [];

    // const allIds = await MasterData.getAllPrimaryKeys('dcs');
    // console.log("all dc ids", allIds);

    syncPromises.push(MasterData.addMasterData(dcs.NewData, 'dcs', 'code'));
    syncPromises.push(MasterData.addMasterData(ownershipTypes.NewData, 'ownershipTypes', 'id'));
    syncPromises.push(MasterData.addMasterData(protocols.NewData, 'qprotocols', 'id'));
    syncPromises.push(MasterData.addMasterData(campaigns.NewData, 'campaign', 'id'));
    syncPromises.push(MasterData.addMasterData(varieties.NewData, 'varieties', 'id'));
    syncPromises.push(MasterData.addMasterData(countries.NewData, 'countries', 'id'));
    syncPromises.push(MasterData.addMasterData(familiesOfVarieties.NewData, 'familiesOfVarieties', 'id'));
    syncPromises.push(MasterData.addMasterData(wayToPay.NewData, 'wayToPay', 'id'));
    syncPromises.push(MasterData.addMasterData(retention.NewData, 'retention', 'id'));
    syncPromises.push(MasterData.addMasterData(business.NewData, 'business', 'id'));
    syncPromises.push(MasterData.addMasterData(vatRate.NewData, 'vatRate', 'id'));
    syncPromises.push(MasterData.addMasterData(zones.NewData, 'zones', 'id'));

    // console.log('*******************', syncPromises);

    syncPromises.push(MasterData.removeMasterData(dcs.RemoveData, 'dcs', 'code'));
    syncPromises.push(MasterData.removeMasterData(ownershipTypes.RemoveData, 'ownershipTypes', 'id'));
    syncPromises.push(MasterData.removeMasterData(protocols.RemoveData, 'qprotocols', 'id'));
    syncPromises.push(MasterData.removeMasterData(campaigns.RemoveData, 'campaign', 'id'));
    syncPromises.push(MasterData.removeMasterData(varieties.RemoveData, 'varieties', 'id'));
    syncPromises.push(MasterData.removeMasterData(countries.RemoveData, 'countries', 'id'));
    syncPromises.push(MasterData.removeMasterData(familiesOfVarieties.RemoveData, 'familiesOfVarieties', 'id'));
    syncPromises.push(MasterData.removeMasterData(wayToPay.RemoveData, 'wayToPay', 'id'));
    syncPromises.push(MasterData.removeMasterData(retention.RemoveData, 'retention', 'id'));
    syncPromises.push(MasterData.removeMasterData(business.RemoveData, 'business', 'id'));
    syncPromises.push(MasterData.removeMasterData(vatRate.RemoveData, 'vatRate', 'id'));
    syncPromises.push(MasterData.removeMasterData(zones.RemoveData, 'zones', 'id'));

    // console.log('*******************1', syncPromises);

    Promise.all(syncPromises).then(() => {
      // console.log('RESULT', result);
      // console.log('ALL SYNC DONE');
    }).catch(() => {
      // console.log('SOMETHING WENT WRONG IN SYNC', error);
    });
  },

  async handleEntitiesData(response) {
    const data = response.Tag;
    const farmers = data.Farmers;
    const fields = data.Fields;
    const crops = data.Crops;
    const contracts = data.Contracts;
    // console.log('ENTITY DATA:', data);

    farmers.NewData = farmers.NewData.map((f) => {
      f.dcs = farmers.DataComplementary.filter((dc) => f.Codigo === dc.farmer);
      return mapERPFarmerToLocal(f);
    });

    await MasterData.addMasterData(farmers.NewData, 'farmers', 'code');
    if (farmers.RemoveData.length > 0) {
      await MasterData.multipleDeleteByKey(farmers.RemoveData.map((rm) => rm.Codigo), 'farmers', 'code');
    }

    for (let i = 0; i < fields.NewData.length; i += 1) {
      const f = fields.NewData[i];
      f.dcs = fields.DataComplementary.filter((dc) => f.Codigo === dc.field) || [];

      // eslint-disable-next-line no-await-in-loop
      fields.NewData[i] = await mapERPFieldToLocal(f);
    }

    // console.log('FIELDS', fields.NewData);
    try {
      await MasterData.addMasterData(fields.NewData, 'fields', 'code');

      if (fields.RemoveData.length > 0) {
        await FieldService.multipleDeleteByKey(fields.RemoveData, 'code');
      }

      for (let i = 0; i < crops.NewData.length; i += 1) {
        const c = crops.NewData[i];
        c.dcs = crops.DataComplementary.filter((dc) => c.code === dc.crop) || [];

        // eslint-disable-next-line no-await-in-loop
        crops.NewData[i] = await mapERPCropToLocal(c);
      }
    } catch (error) {
      console.error(`Error al procesar los FIELDS en la BD Local ${error}`);
    }

    // console.log('CROPS', crops.NewData);
    await MasterData.addMasterData(crops.NewData, 'crops', 'id_external', 'id');
    if (crops.RemoveData.length > 0) {
      await MasterData.multipleDeleteByKey(crops.RemoveData.map((rm) => rm.Codigo), 'crops', 'id_external');
    }
    // console.log('Contratos oussama', contracts);

    for (let i = 0; i < contracts.NewData.length; i += 1) {
      const c = contracts.NewData[i];

      c.lines = contracts.NewDataLines.filter((l) => c.id_external === l.idContract);

      c.lines.forEach((l) => {
        l.dcs = contracts.DataComplementary.filter((dc) => dc.line === l.id_external);
      });

      // eslint-disable-next-line no-await-in-loop
      contracts.NewData[i] = await mapERPContractToLocal(c);
    }

    await MasterData.addMasterData(contracts.NewData, 'contracts', 'id_external', 'id');
    if (contracts.RemoveData.length > 0) {
      await MasterData.multipleDeleteByKey(contracts.RemoveData.map((rm) => rm.Id), 'contracts', 'id_external');
    }
    const syncPromises = [];

    // const allIds = await MasterData.getAllPrimaryKeys('dcs');
    // console.log("all dc ids", allIds);

    // syncPromises.push(MasterData.addMasterData(farmers.NewData, 'farmers', 'code'));
    // syncPromises.push(MasterData.addMasterData(fields.NewData, 'fields', 'code'));
    // syncPromises.push(MasterData.addMasterData(crops.NewData, 'crops', 'id_external'));
    // syncPromises.push(MasterData.addMasterData(campaigns.NewData, 'campaign', 'id'));

    // syncPromises.push(MasterData.removeMasterData(farmers.RemoveData, 'farmers', 'code'));
    // syncPromises.push(MasterData.removeMasterData(fields.RemoveData, 'fields', 'code'));
    // syncPromises.push(MasterData.removeMasterData(crops.RemoveData, 'crops', 'code'));
    // syncPromises.push(MasterData.removeMasterData(campaigns.RemoveData, 'campaign', 'id'));

    const maxVersion = data.MaxVersion;
    if (maxVersion !== '') {
      localStorage.setItem('maxVersionEntities', maxVersion);

      const store = useContractsStore();
      store.lastSyncEntities = new Date().toString();
    }
    // console.log(maxVersion);

    Promise.all(syncPromises).then(() => {
      // console.log('RESULT E', result);
      // console.log('ALL SYNC DONE');
    }).catch(() => {
      // console.log('SOMETHING WENT WRONG IN SYNC', error);
    });
  },
  async getMasterData(versioning, maxVersion) {
    // const url = `${getHostApiERP()}/${ApiModule.PurchaseContracts}/SincronizarMaestros`;
    const Versioning = {
      MaxVersion: maxVersion,
      Versions: versioning,
    };

    return httpClient().post(`${ApiModule.PurchaseContracts}/SincronizarMaestros`, Versioning);
    /* return Axios.post(url, {
      MaxVersion: maxVersion,
      Versions: versioning,
    }); */
  },

  async SendEmailContractPurchase(contract) {
    const contractERP = mapContractToERP(contract);
    return httpClient().post(`${ApiModule.PurchaseContracts}/EnviarContratoCompraCorrreo`, contractERP);
  },

  getGeoServer() {
    return geoServer;
  },
  getGeoServerTimacagro() {
    return geoServerTimacagro;
  },
  getGeoServerRasterDates() {
    return geoServerRasterDates;
  },
  getGeoServerPort() {
    return geoServerPort;
  },
  getGeoServerSigpacMap() {
    return geoServerSigpacMap;
  },
  getGeoServerFeatureInfo() {
    return geoServerFeatureInfo;
  },
  getGeoServerTemperatureHistogram() {
    return geoServerTemperatureHistogram;
  },

  // Reports
  async getReportsGroup(nameApp) {
    return httpClient().get(`${ApiModule.Reports}/ObtenerImpresosNegocioDisponibles/`, {
      params: {
        nombreAPP: nameApp,
      },
    });
  },

  async executeReport(report) {
    return httpClient().post(`${ApiModule.Reports}/EjecutarImpresoAplicacion/`, report);
  },

};
